export const descriptionFieldLimitDefault = 120;
export const entityNameFieldLimitDefault = 40;
